const sections = document.getElementsByClassName('m-faq-rubriek-mobile');

class MobileTabContentLegacy {
  constructor(container) {
    this.container = container;
    this.build();
    this.addEventListeners();
  }

  build() {
    const { container } = this;

    this.rows = container.getElementsByClassName('m-faq-rubriek-mobile__header');
    this.activeRow = null;
  }

  addEventListeners() {
    const { rows } = this;

    [].map.call(rows, row => row.addEventListener('click', this.handleRowClick.bind(this)));
  }

  handleRowClick({ currentTarget }) {
    currentTarget.parentElement.classList.toggle('is-open');
  }
}

function initMobileTabContentsLegacy() {
  [].map.call(sections, section => new MobileTabContentLegacy(section));
}

if (sections) initMobileTabContentsLegacy();